import React from 'react';
import { CheckCircle2, ArrowRight, Calendar } from 'lucide-react';

export default function Hero() {
  return (
    /* LE PARENT : Il impose la contrainte globale d'espace et de hauteur */
    <section className="w-full max-w-7xl mx-auto px-6 lg:px-12 py-6 flex items-center min-h-[calc(100vh/3)]">
      
      {/* LA GRILLE PARENTE : 12 colonnes avec des proportions fixes (5 / 7) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center w-full">
        
        {/* BLOC TEXTE PARENT (Col 5) : Il reçoit les contraintes de disposition */}
        <div className="lg:col-span-5 flex flex-col items-start space-y-4">
          
          <div className="bg-blue-50 text-blue-600 text-xs font-extrabold px-3 py-1.5 rounded-full uppercase tracking-wider">
            LA PLATEFORME DE RELATION CLIENT NOUVELLE GÉNÉRATION
          </div>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-slate-900 leading-tight">
            Votre centre d'appels <span className="text-blue-600">intelligent.</span>
          </h1>

          <p className="text-slate-600 text-sm lg:text-base leading-relaxed">
            Gérez les appels, WhatsApp, les emails, les SMS et vos tickets dans une seule plateforme. Boostez l'expérience client avec l'IA intégrée et des outils puissants.
          </p>

          <div className="flex flex-wrap items-center gap-3 pt-2">
            <button className="bg-primary text-white font-bold text-sm px-5 py-2.5 rounded-xl shadow-md hover:opacity-95 transition-all flex items-center gap-2">
              Essayer gratuitement <ArrowRight size={16} />
            </button>
            <button className="border border-slate-300 text-slate-700 hover:bg-slate-50 font-bold text-sm px-4 py-2.5 rounded-xl flex items-center gap-2 transition-all">
              <Calendar size={16} className="text-slate-500" />
              Réserver une démo
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-y-2 gap-x-5 pt-2 text-xs font-semibold text-slate-500">
            <div className="flex items-center gap-1.5">
              <CheckCircle2 size={15} className="text-blue-600" />
              <span>Installation en 5 min</span>
            </div>
            <div className="flex items-center gap-1.5">
              <CheckCircle2 size={15} className="text-blue-600" />
              <span>Aucune CB requise</span>
            </div>
            <div className="flex items-center gap-1.5">
              <CheckCircle2 size={15} className="text-blue-600" />
              <span>Support 24/7</span>
            </div>
          </div>

        </div>

        {/* BLOC IMAGE PARENT (Col 7) : Il offre l'espace nécessaire à l'image sans la rogner */}
        <div className="lg:col-span-7 relative flex items-center justify-center">
          
          {/* Blob décoratif en arrière-plan */}
          <div className="absolute -inset-4 -z-10 flex items-center justify-center pointer-events-none">
            <svg
              viewBox="0 0 700 600"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-full h-full opacity-80"
            >
              <defs>
                <linearGradient id="blob-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#E0F2FE" stopOpacity="0.8" />
                  <stop offset="50%" stopColor="#BAE6FD" stopOpacity="0.6" />
                  <stop offset="100%" stopColor="#DBEAFE" stopOpacity="0.9" />
                </linearGradient>
              </defs>
              <path
                d="M600,250 C650,380 580,520 440,550 C300,580 180,510 120,400 C60,290 100,160 220,90 C340,20 550,120 600,250 Z"
                fill="url(#blob-gradient)"
              />
            </svg>
          </div>

          {/* Grille de points en arrière-plan */}
          <div className="absolute top-1/2 -right-4 -translate-y-1/2 w-16 h-36 opacity-30 -z-10 pointer-events-none bg-[radial-gradient(#3B82F6_2px,transparent_2px)] [background-size:14px_14px]" />

          {/* Conteneur de l'image */}
          <div className="w-full rounded-2xl overflow-hidden shadow-2xl border border-slate-200/80 bg-white relative z-10">
            <img
              src="/hero/dashboard-izicall_center.jpg"
              alt="Tableau de bord Izi Callcenter"
              className="w-full h-auto block"
            />
          </div>

        </div>

      </div>
    </section>
  );
}